import { useStore } from "../store/store";
import { normalizePhoneNumber } from "../utils/normalizePhoneNumber";

export const useActiveCallForPhone = (phone: string | null | undefined) => {
    const matchingCall = useStore((state) => {
        const normalizedInput = normalizePhoneNumber(phone);
        if (!normalizedInput) {
            return null;
        }
        const calls = Object.values(state.liveCalls.bySessionId);
        const match = calls.find((call) => normalizePhoneNumber(call.phoneNumber) === normalizedInput);
        return match ?? null;
    });
    return matchingCall;
};
